(ns dashboard.views.browser-extension.questionnaire-list.config)

(def view-id :route.view/extension-questionnaire-list)
